import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions } from './index';
import { FileData } from '../types';
import { Comment } from '../comment';

export interface CategoryByIdSubCategory {
  id: string;
  header: string;
  isActive: boolean;
  description: string | null,
  customerAvgPercent: number;
  customerAvgValue: number;
  workerAvgPercent: number;
  workerAvgValue: number;
}

export type CategoryByIdData = {
  header: string;
  description: string;
  shortDescription: string;
  author: string;
  file: FileData | null;
  id: string;
  name: string;
  isActive: boolean;
  comments: Comment[],
  subCategories: CategoryByIdSubCategory[];
};


export type CategoryByIdResponse = CategoryByIdData

export interface CategoryByIdParams {
  id: string;
}

export const categoryById = (payload: CategoryByIdParams): Action<CategoryByIdParams> => ({
  type: actions.categoryByIdTrigger.toString(),
  payload,
});

export const categoryByIdClear = (): Action => ({
  type: actions.categoryByIdClear.toString(),
});

export const categoryByIdErrorClear = (): Action => ({
  type: actions.categoryByIdErrorReset.toString(),
});

export function* categoryByIdRequestSaga({ payload }: Action<CategoryByIdParams>) {
  yield put({
    type: actions.categoryByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.categoryByIdError.toString(),
      payload: {
        message: 'CategoryById: Parameters not passed.',
      },
    });

    return;
  }

  const { id, ...params } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${config.api.url}categories/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        params: new URLSearchParams(params).toString(),
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<CategoryByIdData, CategoryByIdResponse>(
    response,
    actions.categoryByIdSuccess.toString(),
    actions.categoryByIdError.toString(),
    false,
  );
}

export default function* saga() {
  yield takeLatest(
    actions.categoryByIdTrigger.toString(),
    defaultProcessingSaga(
      categoryByIdRequestSaga,
      {
        error: actions.categoryByIdError.toString(),
        locationCancel: actions.categoryByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.categoryByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.categoryByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.categoryByIdErrorReset.toString(),
    });
  });
}
